import { Snapshot } from 'app/agriculture/queries/snapshots/types/Snapshot';
import { filterSnapshots } from 'app/agriculture/queries/snapshots/utils/filterSnapshots';
import { Duration } from 'date-fns';
import { SnapshotsMap } from 'app/agriculture/queries/snapshots/types/SnapshotsMap';
import { SnapshotMap } from 'app/agriculture/queries/snapshots/types/SnapshotMap';
import {
    SnapshotInterface,
    SnapshotType,
} from 'app/agriculture/queries/snapshots/config/snapshotConfig';
import { TZDate } from '@date-fns/tz';

interface Options {
    shelfLife: Duration | null;
    cursorTime?: Date;
    timeZone: string;
}

/**
 * returns only the latest snapshot before cursorTime for each parentId
 * as long as that snapshot is within the specified shelf life
 */
export function filterSnapshotsMap<
    T extends SnapshotType,
    I extends Snapshot = SnapshotInterface<T>,
>(snapshotsMap: SnapshotsMap<I>, { shelfLife, cursorTime, timeZone }: Options): SnapshotMap<I> {
    const filteredSnapshotsMap: SnapshotMap<I> = new Map<I['parentId'], I | null>();
    for (const [parentId, snapshots] of snapshotsMap.entries()) {
        const [latestSnapshot] = filterSnapshots(snapshots, { shelfLife, cursorTime });
        if (latestSnapshot == null) {
            filteredSnapshotsMap.set(parentId, null);
        } else {
            filteredSnapshotsMap.set(parentId, {
                ...latestSnapshot,
                timestamp: new TZDate(latestSnapshot.timestamp, timeZone),
            });
        }
    }
    return filteredSnapshotsMap;
}
